import Vue from 'vue';
import Router from 'vue-router';
import RegLayout from '../pages/register/layout.vue';
import RegStepOne from '../pages/register/stepone.vue';
import RegJoin from '../pages/register/join.vue';
import LoginLayout from '../pages/login/layout.vue';
import Login from '../pages/login/login.vue';
import WXLogin from '../pages/login/wechatLogin.vue';
import Register from '../pages/login/register.vue';
import PwdFindStepOne from '../pages/login/mmzhStepone.vue'; // 密码找回第一步
import PwdFindStepTwo from '../pages/login/mmzhSteptwo.vue'; // 密码找回第一步
import Regcreate from '../pages/register/create.vue'; // 创建企业
import Hrinfo from '../pages/register/hrinfo.vue'; // 创建人填写自己信息
import Regsuc from '../pages/register/regsuc.vue';
import Hrapply from '../pages/register/hrapply.vue';
import Loginsel from '../pages/login/select.vue';
import Loginyz from '../pages/login/yzlogin.vue';
import PostReleasejob from '../pages/posts/release.vue'; //发布岗位
import BatchAi from '../pages/posts/btachAi.vue';
import PostList from '../pages/posts/list.vue'; // 岗位列表
import ResumeList from '../pages/resume/list.vue';
import ResumeInfo from '../pages/resume/info.vue';
import Finance from '../pages/finance/finance.vue';
import ModifyPayPassword from '../pages/finance/modifyPayPassword.vue';
import setPayPassword from '../pages/finance/setPayPassword.vue';
import searchList from '../pages/resume/searchlist.vue';
import searchlistInfo from '../pages/resume/searchlistInfo.vue';
import SeeInfo from '../pages/resume/seeinfo.vue';
import MyList from '../pages/resume/mylist.vue';
import ReCharge from '../pages/finance/recharge.vue';
import ChargeSuc from '../pages/finance/chargeSuc.vue';
import MemberInfo from '../pages/member/info.vue'; // 会员信息
import MemberBuy from '../pages/member/buy.vue'; // 购买
import MemberRenew from '../pages/member/renew.vue';
import Home from '../pages/home/home.vue';
import MainHome from '../pages/home/outerIndex.vue';
import CompanyInfo from '../pages/finance/company.vue';
import CompanyBase from '../pages/finance/companyBase.vue';
import CompanyAuth from '../pages/finance/companyAuth.vue';
import InvoiceList from '../pages/finance/invoiceList.vue';
import InvoiceInfo from '../pages/finance/invoiceInfo.vue';
import Person from '../pages/home/person.vue';
import Compyrz from '../pages/home/compyrz.vue';
import StaffList from '../pages/staff/list.vue';
import StaffChangeAdm from '../pages/staff/changeadm.vue';
import Index from '../pages/index.vue';
import AddConform from '../pages/resume/confirm.vue';
import Jobfair from '../pages/home/jobfair.vue'; // 招聘会列表
import Jobfairinfo from '../pages/home/jobfairinfo.vue'; // 招聘会详情
import Jobfairseat from '../pages/home/Jobfairseat.vue'; // 招聘会选座
import ValuationInfo from '../pages/home/valuation.vue'; // 评价
import NoticeList from '../pages/notice/list.vue';
import NoticeDetail from '../pages/notice/detail.vue';
import Album from '../pages/album/index.vue';

// import productIndex from '../pages/product/index.vue';

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash === '#tab') {
      return {
        selector: to.hash
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    // {
    //   path: '/home',
    //   component: MainHome
    // },
    {
      path: '/login',
      component: LoginLayout,
      children: [
        {
          path: '',
          component: Login,
          meta: {
            needlogin: 1
          }
        },
        {
          path: '/register',
          component: Register,
          meta: {
            needlogin: 1
          }
        },
        {
          path: '/login/select',
          component: Loginsel,
          meta: {
            needlogin: 1
          }
        },
        {
          path: '/yzlogin',
          component: Loginyz,
          meta: {
            needlogin: 1
          }
        },
        {
          path: '/wxlogin',
          component: WXLogin,
          meta: {
            needlogin: 1
          }
        },
        {
          path: '/pwdfindone',
          component: PwdFindStepOne,
          meta: {
            needlogin: 1
          }
        },
        {
          path: '/pwdfindtwo',
          component: PwdFindStepTwo,
          meta: {
            needlogin: 1
          }
        }
      ]
    },
    {
      path: '/register',
      component: RegLayout,
      children: [
        {
          path: '',
          component: RegStepOne
        },
        {
          path: 'step',
          component: RegStepOne
        }, {
          path: 'join',
          component: RegJoin
        },
        {
          path: 'create',
          component: Regcreate
        },
        {
          path: 'hrinfo',
          component: Hrinfo,
          meta: {
            needlogin: 3
          }
        },
        {
          path: 'regsuc',
          component: Regsuc
        },
        {
          path: 'hrapply',
          component: Hrapply
        }
      ]
    },
    {
      path: '/index',
      component: Index,
      children: [
        {
          path: 'home/index',
          component: Home,
          alias: 'home'
        },
        {
          path: 'home/notice',
          component: NoticeList
        },
        {
          path: 'home/notice/detail',
          component: NoticeDetail
        },
        {
          path: 'jobfair',
          component: Jobfair
        },
        {
          path: 'home/compyrz',
          component: Compyrz
        },
        {
          path: 'home/person',
          component: Person
        },
        {
          path: 'jobfair/info',
          component: Jobfairinfo
        },
        {
          path: 'jobfair/seat',
          component: Jobfairseat
        },
        {
          path: 'home/valuation',
          component: ValuationInfo
        },
        {
          path: 'posts/ai',
          component: BatchAi,
          // alias: 'posts/ai'
        },
        {
          path: 'posts/release',
          component: PostReleasejob,
          alias: 'posts/edit'
        },
        {
          path: 'posts/list',
          component: PostList,
          alias: 'posts'
        },
        {
          path: 'resume/list',
          component: ResumeList
        },
        {
          path: 'resume/info',
          component: ResumeInfo
        },
        {
          path: 'finance/index',
          component: Finance,
          alias: 'finance'
        },
        {
          path: 'finance/modifyjypwd',
          component: ModifyPayPassword
        },
        {
          path: 'finance/setjypwd',
          component: setPayPassword
        },
        {
          path: 'finance/recharge',
          component: ReCharge
        },
        {
          path: 'finance/rechargesuc',
          component: ChargeSuc
        },
        {
          path: 'finance/invoice/list',
          component: InvoiceList
        },
        {
          path: 'finance/invoice/info',
          component: InvoiceInfo
        },
        {
          path: 'album',
          component: Album
        },
        {
          path: 'searchlist',
          component: searchList,
          children: [
            {
              path: 'conform',
              component: AddConform
            }
          ],
          meta: {
            showsearch: true
          }
        },
        {
          path: 'searchlistInfo',
          component: searchlistInfo
        },
        {
          path: 'resume/seeinfo',
          component: SeeInfo,
          children: [
            {
              path: 'conform',
              component: AddConform
            }
          ]
        },
        {
          path: 'resume/mylist',
          component: MyList
        },
        {
          path: 'member/info',
          component: MemberInfo,
          children: [
            {
              path: 'renew',   // 会员续费
              component: MemberRenew
            }
          ]
        },
        {
          path: 'member/buy',
          component: MemberBuy
        },
        {
          path: 'companyinfo',
          component: CompanyInfo,
          alias: 'company'
        },
        {
          path: 'company/base',
          component: CompanyBase
        },
        {
          path: 'company/auth',
          component: CompanyAuth
        },
        {
          path: 'staff/list',
          component: StaffList,
          alias: 'staff'
        },
        {
          path: 'staff/changeadm',
          component: StaffChangeAdm
        },
        // {
        //   path: 'product/index',
        //   component: productIndex,
        //   alias: 'product'
        // }
      ]
    },
    {
      path: "/:pathMatch(.*)*",
      beforeEnter: (to, from, next) => {
        const whiteList = ['/chat'];
        const isAllowed = whiteList.some(pattern =>
          new RegExp(`^${pattern}$`.replace(/\*/g, '.*')).test(to.path)
        );
        isAllowed ? next() : next('/index/home/index');
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js